import Input from './Input';

// export types
export type { InputProps } from './Input';

// export components
export { Input };
export default Input;
